<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('materialproductlot_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-qrcode</v-icon>{{$t('profile.material.productlot')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-materialproductlot-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.number') }}</strong></td>
              <td>
                {{ item['number'] }}
              </td>
              <td><strong>{{ $t('profile.material.productversion') }}</strong></td>
              <td>
                <span v-if="item['materialProductVersion']">{{ item['materialProductVersion'].name }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.externallot') }}</strong></td>
              <td>
                {{ item['externalLot'] }}
              </td>
              <td></td>
              <td>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.dlu') }}</strong></td>
              <td>
                {{ formatDate(item['dlu']) }}
              </td>
              <td><strong>{{ $t('profile.material.datemanufacture') }}</strong></td>
              <td>
                {{ formatDate(item['dateManufacture']) }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.file') }}</strong></td>
              <td>
                                    <v-btn
                                        v-if="item['file']"
                                        color="secondary"
                                        class=""
                                        @click="downloadFileByObject(item)"
                                      >
                                        {{ $t('global.download') }}
                                        <v-icon
                                          right
                                          dark
                                        >mdi-download
                                        </v-icon>
                                      </v-btn>
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'MaterialProductLot';

export default {
  name: 'MaterialProductLotShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('materialproductlot', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('materialproductlot', ['find'])
  },
  methods: {
    ...mapActions('materialproductlot', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
